import {
  SET_TRANSPORT_PROPERTY,
  TRANSPORT_UPDATE_MASTER_DATA,
  TRANSPORT_RESET_FILTERS,
  TRANSPORT_GET_DRIVERS,
  TRANSPORT_RESET_EMPLOYEES_FILTERS,
  TRANSPORT_RESET_DRIVER_FILTERS,
  SET_ACT_CHECKLIST_INTERIOR_ACCESSORIES,
  SET_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM,
  DELETE_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM,
  SET_ACT_CHECKLIST_INTERIOR_BREAKS_ITEM,
  EDIT_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM,
  SET_ACT_CHECKLIST_EXTERIOR_ACCESSORIES,
  ACT_RESET_DATA_TO_SEND,
  UI_UPDATE_FROM_PARTNER,
  TRANSPORT_ACT_RESET_TIRES,
  UPDATE_RISK_OFFLINE
} from 'store/actions/transport';
import { setValueObjectByField, mapOptionsMasterData } from 'helpers/object';

export default {
  [SET_TRANSPORT_PROPERTY]: (state, { field, value }) => {
    setValueObjectByField(state, field, value);
  },

  [TRANSPORT_UPDATE_MASTER_DATA]: (state, data) => {
    const { transportStatus, transportTypes, transportProviders, reasonRejection } = data;
    state.transportStatus = mapOptionsMasterData(transportStatus);
    state.transportTypes = mapOptionsMasterData(transportTypes);
    state.transportProviders = mapOptionsMasterData(transportProviders);
    state.reasonRejectionOptions = mapOptionsMasterData(reasonRejection);
  },

  [TRANSPORT_RESET_FILTERS]: state => {
    state.filtersManagerTransportList = {
      idType: '',
      idState: '',
      plate: ''
    };
    state.filtersHasChanged = false;
  },

  [TRANSPORT_RESET_EMPLOYEES_FILTERS]: state => {
    state.filterEmployeesTransportList = {
      idProvider: '',
      idType: '',
      idState: '',
      plate: ''
    };
    state.filtersHasChanged = false;
  },

  [TRANSPORT_RESET_DRIVER_FILTERS]: state => {
    state.filterDriverTransportList = {
      idType: '',
      idState: '',
      plate: ''
    };
    state.filtersHasChanged = false;
  },

  [TRANSPORT_GET_DRIVERS]: (state, drivers) => {
    state.transportDrivers = mapOptionsMasterData(drivers);
  },

  [SET_ACT_CHECKLIST_INTERIOR_ACCESSORIES]: (state, { idAccesory, value, property }) => {
    const { intAccesoriesCar } = state.act.variable;
    state.act.variable.intAccesoriesCar = intAccesoriesCar.map(checklistItemValue => {
      if (checklistItemValue.idAccesory === idAccesory) {
        return {
          ...checklistItemValue,
          [property]: value
        };
      }
      return checklistItemValue;
    });
  },

  [SET_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM]: (state, { code }) => {
    const damagesCar = state.act.variable.damagesCar;
    const damageCar = damagesCar.find(el => el.codDamage === code);
    if (damageCar) {
      damageCar.isDamaged = true;
      state.checklistsExternalBreaks.push(damageCar);
    }
  },

  [DELETE_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM]: (state, { code }) => {
    const damagesCar = state.act.variable.damagesCar;
    const damageCar = damagesCar.find(el => el.codDamage === code);
    if (damageCar) {
      damageCar.isDamaged = false;
      state.checklistsExternalBreaks = state.checklistsExternalBreaks.filter(
        el => el.codDamage !== code
      );
    }
  },

  [EDIT_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM]: (state, { code, data }) => {
    state.checklistsExternalBreaks = state.checklistsExternalBreaks.map(el => {
      if (el.codDamage !== code) return el;
      return {
        ...el,
        ...data
      };
    });
  },

  [SET_ACT_CHECKLIST_INTERIOR_BREAKS_ITEM]: (state, { id, value }) => {
    const interiorDamage = state.act.variable.intDamagesCar;
    const interiorDamageItem = interiorDamage.find(el => el.codDamage === id);
    if (interiorDamageItem) {
      interiorDamageItem.isDamaged = value;
    }
  },

  [SET_ACT_CHECKLIST_EXTERIOR_ACCESSORIES]: (state, { idAccesory, value, property }) => {
    const { accesoriesCar } = state.act.variable;
    state.act.variable.accesoriesCar = accesoriesCar.map(checklistItemValue => {
      if (checklistItemValue.idAccesory === idAccesory) {
        return {
          ...checklistItemValue,
          [property]: value
        };
      }
      return checklistItemValue;
    });
  },

  [ACT_RESET_DATA_TO_SEND]: state => {
    state.checklistsExternalBreaks = [];
  },

  [UI_UPDATE_FROM_PARTNER]: (state, { patternId, data }) => {
    const { risk } = data;
    state.risk[patternId] = risk;
  },

  [TRANSPORT_ACT_RESET_TIRES]: (state, { field, value, storageAct, reset }) => {
    reset.forEach(fieldReset => {
      setValueObjectByField(state, `${storageAct}.variable.${fieldReset}`, null);
    });
    setValueObjectByField(state, field, value);
  },

  [UPDATE_RISK_OFFLINE]: (state, { type, data }) => {
    const { risk } = data;
    state.offline.risk[type] = risk;
  }
};
